import { render, staticRenderFns } from "./WorkIconWord.vue?vue&type=template&id=9f7e03be"
import script from "./WorkIconWord.vue?vue&type=script&lang=js"
export * from "./WorkIconWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports